import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import { useGlassData } from './useGlassData';

const GlazingType = ({ value, onChange, id='GlazingType', label = 'Glazing Type', disabled = false, showPics = false, appliesTo = 'windows' }) => {
    const { getGlazingTypes, loading } = useGlassData(appliesTo);
    const options = getGlazingTypes();
    const defaultValue = options.length > 0 ? options[0].value : "Double";
    const [selectedGlazingType, setSelectedGlazingType] = useState(value || defaultValue);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedGlazingType(value || defaultValue);
    }, [value, defaultValue]);

    const handleGlazingTypeChange = (e) => {
        setSelectedGlazingType(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGlazingType}
                onChange={handleGlazingTypeChange}
            >
                {options.map(opt => (
                    <option key={opt.id} value={opt.value}>
                        {selectedGlazingType === opt.value ? `${opt.label} ✔` : opt.label}
                    </option>
                ))}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/GlazingType"
                imageName={selectedGlazingType}
                width={200}
                height={250}
            />
        </div>
    );
};

export default GlazingType;
